export default __webpack_public_path__ + "static/media/sticker-M.5136dbd3.png";